// extracted by mini-css-extract-plugin
export var firstSection = "home-module--firstSection--2z7FK";
export var titleAndDescription = "home-module--titleAndDescription--rZ6cM";
export var title = "home-module--title--1fXPQ";
export var description = "home-module--description--1Mo1d";
export var viewService = "home-module--viewService--3cgXQ";
export var videoWrap = "home-module--videoWrap--3BRTO";
export var imgOfSection = "home-module--imgOfSection--3K2jj";
export var sliderWrap = "home-module--sliderWrap--3tNTU";